import React from 'react';
import { createRoot } from 'react-dom/client';
import { AdminAIReportFeedbackDetailPage, type AdminAIReportFeedbackDetailPageProps } from '../ui/admin/AdminAIReportFeedbackDetailPage';

export function AdminAIReportFeedbackDetailPageContainer(props: AdminAIReportFeedbackDetailPageProps) {
  return <AdminAIReportFeedbackDetailPage {...props} />;
}

export function mountAdminAIReportFeedbackDetailPage(
  container: HTMLElement,
  props: AdminAIReportFeedbackDetailPageProps
) {
  const root = createRoot(container);
  root.render(<AdminAIReportFeedbackDetailPageContainer {...props} />);
  return root;
}

export default AdminAIReportFeedbackDetailPageContainer;
